import { Input } from '@iwoca/orion';
import { UseFormRegister } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { TFormValues } from '../StripeLinkDebitCardForm';

export function CardholderNameField({
    formRegister,
    error,
    className,
    placeholder = 'John Smith'
}: {
    formRegister: UseFormRegister<TFormValues>;
    error?: string;
    className?: string;
    placeholder?: string;
}) {
    return (
        <DebitCardFieldWrapper
            label={
                <FormattedMessage
                    id="_.link_debit_card.cardholder_name"
                    defaultMessage="Cardholder name"
                />
            }
            htmlFor="cardholderName"
            error={error ?? null}
            className={className}
        >
            <Input
                type="text"
                id="cardholderName"
                placeholder={placeholder}
                className="fs-exclude"
                {...formRegister('cardholderName')}
            />
        </DebitCardFieldWrapper>
    );
}
